import { React, useEffect, useState, useRef } from "react";
import { Helmet } from 'react-helmet-async';
import createClient from '../Client';
import {
    Feature, Process, ImageBlock, Screenshots, Title, About, Groups,Tutorial,TeamProfile, Contact,
    Pricing, Video, Testimonials, Blog, Breaker, BoxContent, ContentSection
} from "../components";
import { useLocation, Link } from 'react-router-dom';
import { PortableText } from '@portabletext/react';
import Loader from "../components/Loader";
import BoxContentNotGroup from "../components/BoxContentNotGroup";
import HowToSection from "../components/HowToSection";


const serializers = {

    marks: {
        link: ({ children, value }) => {
            const rel = !value.href.startsWith('/') ? 'noreferrer noopener' : undefined
            const target = '_blank'
            const className = 'link'

            return (
                <a href={value.href} rel={rel} target={target} className={className}>
                    {children}
                </a>
            )
        },
    },
};

//static page
const StaticPages = ({ setLoading, footerData, items }) => {
    
    const [staticData, setStaticData] = useState([]);
    const location = useLocation();
    //this is static, static page about-us is changed to home
    const slugId = location.pathname.split('/')[1];
    // const slugId = "about-us";

    const logoRef = useRef(null);
    // const [loading, setLoading] = useState(true);
    const boxContentData = [];
    let renderedBoxContent = false;
    const [loadingStatic, setLoadingStatic] = useState(true); 


    

    useEffect(() => {
        if (location.hash) {
            // Delay scrolling slightly
            setTimeout(() => {
                const targetId = location.hash.substring(1);
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.offsetTop - 100,
                        behavior: 'smooth',
                    });
                }
            }, 100); // Adjust the delay as needed
        }
    }, [location.hash]);

    // useEffect(() => {
    //     setTimeout(() => {
    //         setLoading(false);
    //     }, 400);
    // }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const handleLogoClick = () => {
        setLoading(true);
        // setTimeout(() => {
        //     setLoading(false);
        // }, 400); // adjust the timeout value as needed
    };

    useEffect(() => {
        setLoading(true); 
        createClient.fetch(`*[_type == "pages" && page_slug.current == "${slugId}"][0]{
              "pageBannerImage": page_banner_image.asset->url,
              "bannerImageEnable":page_banner_check,
              "staticImage":page_featured_image.asset->url,
              "staticTitle":page_title,
              "staticSubTitle": page_sub_title,
              "staticDes" : page_content,
              "staticDesHTML" : page_content_html,
              "template":sel_page_template,
              "slug":page_slug.current,
              "display_block_content_only": page_block_section_content_only_display,
              "seoTitle": seo_title,
              "seoDescription": seo_description,
              "seoOgImage": seo_og_image.asset->url,
              "seoNoIndex": seo_no_index,
              ...,
              moduleBlock[]{
              ...,
                  _type == "gallery" => { 
                      "imageUrl": images[].asset->url
                      },
                      _type == "video" => { 
                      "imageUrl": video_thumbnail_image.asset->url
                      },
                      _type == "cc_img_section" => { 
                        "imageUrl": cc_img.asset->url
                      },
                     _type == "cc_box_content" => {
                        "boxSectiontitle": cc_box_content_title,
                        "boxSectioncontent": cc_box_content_content,
                        "boxSectionwidth": cc_box_content_width,
                        "boxSectionalignment": cc_box_content_alignment,
                        "imageUrl": cc_box_content_images[].asset->url
                    },
                      _type=="reference"=> {
                        ...,
                      'slug': @->page_slug.current,
                      "aboutImage":@->page_featured_image.asset->url,
                      "aboutTitle":@->page_title,
                      "aboutSubTitle": @->page_sub_title,
                      "aboutDes" : @->page_content,
                      "aboutDesHTML" : @->page_content_html,
                      "template":@->sel_page_template,
                      },
                      _type == "group" => {
                      ...,
                      moduleBlockNoGroup[]{
                      ...,
                      _type == "gallery" => { 
                          "imageUrl": images[].asset->url
                      },
                      _type == "video" => { 
                          "imageUrl": video_thumbnail_image.asset->url
                      },
                      _type == "cc_box_content" => {
                        "boxSectiontitle": cc_box_content_title,
                        "boxSectioncontent": cc_box_content_content,
                        "boxSectionwidth": cc_box_content_width,
                        "boxSectionalignment": cc_box_content_alignment,
                        "imageUrl": cc_box_content_images[].asset->url
                        },
                      _type == "cc_img_section" => { 
                        "imageUrl": cc_img.asset->url
                      },
                      }
                      }
              }
          }`).then((data) => {
            setStaticData(data);
            setLoadingStatic(false); // Local loading complete
            // setTimeout(() => {
                setLoading(false); // Add 400ms delay before setting global loading to false
            // }, 400); 
          
        })
        .catch((error) => {
            console.error(error);
            setLoadingStatic(false); // Make sure the loader dissapears even on error
            // setTimeout(() => {
                setLoading(false); // Add 400ms delay before setting global loading to false
            // }, 400);
        });
            // .catch(console.error);
            // setLoadingStatic(false);
            //     setLoading(false);

    }, [slugId, setLoading]);
    
    if (loadingStatic) {
        return <Loader />; // Use local loading state
    }

    if (!staticData || staticData.slug === undefined) {
        return (
            <>
             <div className="container default">
                <div className="row">
                    <div className="col-12 col-lg-12">
                        <div className="error_page_wrapper">
                            <h2>Hi 👋 Sorry We Can’t Find That Page!</h2>
                            <p>Oops! The page you are looking for does not exist. It might have been moved or deleted.</p>
                            <div className="buton404">
                                <Link className="btn btn--primary" to='/' onClick={handleLogoClick}>Go Back Home</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </>

        );
    }

    return (
        <>
            {/* {loading && <Loader />} */}
              
            {/* {staticData && staticData.slug === undefined ?
                <>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-12">
                                <div className="error_page_wrapper">
                                    <h2>Hi 👋 Sorry We Can’t Find That Page!</h2>
                                    <p>Oops! The page you are looking for does not exist. It might have been moved or deleted.</p>
                                    <div className="buton404">
                                        <Link className="btn btn--primary" to='/' onClick={handleLogoClick} > Go Back Home
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </> : */}

                <>
                    <Helmet>
                        <title>{staticData.seoTitle || `${staticData.staticTitle} | OrthoPed`}</title>
                        <meta name="description" content={staticData.seoDescription || ''} />
                        <link rel="canonical" href={`https://www.orthoped.ai/${staticData.slug}`} />
                        <meta property="og:title" content={staticData.seoTitle || staticData.staticTitle} />
                        <meta property="og:description" content={staticData.seoDescription || ''} />
                        <meta property="og:image" content={staticData.seoOgImage || 'https://www.orthoped.ai/logoImage.png'} />
                        <meta property="og:url" content={`https://www.orthoped.ai/${staticData.slug}`} />
                        <meta property="og:type" content="website" />
                        <meta name="twitter:card" content="summary_large_image" />
                        {staticData.seoNoIndex && <meta name="robots" content="noindex" />}
                    </Helmet>
                    {staticData && staticData.bannerImageEnable ?
                        <div className="container-fluid p-0">
                            <div className='col-12'>
                                <div className='row banner-wrapper-container' style={{ backgroundImage: `url(${staticData.pageBannerImage})` }}>
                                    <div className="container banner-title-wrapper">
                                        {/* <h2 className="heading-title">{staticData.staticSubTitle}</h2> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        : ""}
                    {staticData && staticData.display_block_content_only ?
                        ""
                        :
                        <section className="about static-page">
                            <div className="container">


                                {staticData && staticData.template == 'two-column' ?
                                    <div className="row align-items-center text-center-xs">
                                        <div className="col-12 col-lg-12">
                                            <div className="heading mb-40">
                                                <p className="heading-subtitle">{staticData.staticSubTitle}</p>
                                                <h2 className="heading-title">{staticData.staticTitle}</h2>
                                            </div>
                                        </div>

                                        {staticData && staticData.staticImage ? <>
                                            <div className="col-12 col-lg-5">
                                                <img className="two-col-img  img-fluid" src={staticData.staticImage} />
                                            </div>
                                            <div className="col-12 col-lg-7">

                                                <div className="boxWrapper">
                                                    <div className="heading">
                                                        <span className="heading-desc"> <PortableText value={staticData.staticDesHTML} components={serializers} ></PortableText></span>
                                                    </div>

                                                </div>
                                            </div>
                                        </> :
                                            <div className="col-12 col-lg-7">

                                                <div className="boxWrapper">
                                                    <div className="heading">
                                                        <span className="heading-desc"> <PortableText value={staticData.staticDesHTML} components={serializers} ></PortableText></span>
                                                    </div>

                                                </div>
                                            </div>
                                        }

                                    </div>
                                    : <div className="row align-items-center text-center-xs">

                                        <div className="col-12">
                                            <div className="heading mb-40">
                                                <p className="heading-subtitle">{staticData && staticData.staticSubTitle}</p>
                                                <h2 className="heading-title">{staticData && staticData.staticTitle}</h2>
                                            </div>
                                            {staticData && staticData.staticImage ? <> <img className="single-image img-fluid" src={staticData && staticData.staticImage} />
                                                <div className="heading mb-40">
                                                    <span className="heading-desc"> <PortableText value={ staticData && staticData.staticDesHTML} components={serializers} ></PortableText></span>
                                                </div></>
                                                :
                                                <div className="heading mb-40">
                                                    <span className="heading-desc"> <PortableText value={staticData && staticData.staticDesHTML} components={serializers} ></PortableText></span>
                                                </div>}

                                        </div>
                                    </div>
                                }
                            </div>
                        </section>
                    }
                    

                    {staticData && staticData.moduleBlock && staticData.moduleBlock.map((dataItem, index) => {
                        switch (dataItem._type) {
                            case 'cc_title_section':
                                return <Title title={dataItem.cc_title_section_heading} subTitle={dataItem.cc_title_section_title} />;
                            case 'modules':
                                switch (dataItem.custom_module_blocks) {
                                    case 'news_module':
                                        return <Blog />;
                                    case 'features_module':
                                        return <Feature />;
                                    case 'testimonials_module':
                                        return <Testimonials />;
                                    case 'prices_module':
                                        return <Pricing />;
                                    case 'teams_module':
                                        return <TeamProfile />;
                                    case 'contact_form_module':
                                        return <Contact />;
                                    case 'how_to_module':
                                        return <HowToSection />;
                                    default:
                                        return null;
                                }
                            case 'reference':
                                return <About aboutData={dataItem}></About>;
                            case 'cc_accordion':
                                return <Process data={dataItem.groups} />;
                            case 'tutorial':
                                return <Tutorial data={dataItem.groups} />;
                            case 'gallery':
                                return <Screenshots data={dataItem.imageUrl} />;
                            case 'video':
                                return <Video data={dataItem} />;
                            case 'group':
                                return <Groups data={dataItem.moduleBlockNoGroup} color={dataItem.favoriteColor}/>;
                            case 'cc_img_section':
                                return <ImageBlock data={dataItem}></ImageBlock>;
                            case 'cc_breaker':
                                return <Breaker></Breaker>;
                            case 'cc_content_section':
                                return <ContentSection data={dataItem}/>;
                            // case 'cc_box_content':
                            //     boxContentData.push(dataItem);  
                            //     if (!renderedBoxContent) {
                            //         renderedBoxContent = true; // Set the flag to true so no further BoxContent is rendered
                            //         return <BoxContent key={index} data={boxContentData} />;
                            //     }
                            //     return null; 
                            case 'cc_box_content':
                               
                                return <BoxContentNotGroup data={dataItem} />;
                                
                             
                            default:
                                return null;
                        }
                    })}

                </>
                {/* } */}

        </>
    );
}

export default StaticPages;